import type { FilterOption } from '@app/types/filter'

export const getSelectedValues = (options?: FilterOption | FilterOption[] | null): string[] => {
  if (Array.isArray(options)) {
    return options.map(option => option.value?.toString() ?? '')
  }

  return []
}
